export default __webpack_public_path__ + "static/thinkanew-media-full-logo-white-bg-6f5252ab373f05c0c386affeaf5e130e.svg";